export const certification : string[] = [
    'Student',
    'Private',
    'Sport',
    'Recreational',
    'Commercial',
    'Flight Instructor',
    'Air Transport Pilot',
    'Military'
]